import { css } from "styled-components"

import theme from "@styles/theme"

/**
 * All breakpoints can be found inside of theme.breakpoints.
 * Each is turned in to a min and max-width version.
 *
 *
 * @example
 *
 *    ${media.phone` width: 100px; `};
 *    ${media.tablet_up` width: 200px; `};
 */

const media = theme.breakpoints.reduce(
  (acc, [label, size], i) => ({
    ...acc,
    // max-width media query e.g. media.desktop
    [label]: (...args) => css`
      @media only screen and (max-width: ${size}px) {
        ${css(...args)};
      }
    `,
    // min-width media query e.g. media.desktop_up
    [`${label}_up`]: (...args) => css`
      @media only screen and (min-width: ${theme.breakpoints[i][1] + 1}px) {
        ${css(...args)};
      }
    `,
  }),
  {}
)

export default media
/**
  breakpoints: [
    ["xs", 376],
    ["sm", 768],
    ["md", 992],
    ["lg", 1200],
  ],
 */